import { render, staticRenderFns } from "./DesignDeliveryView.vue?vue&type=template&id=0acd3165&scoped=true"
import script from "./DesignDeliveryView.vue?vue&type=script&lang=js"
export * from "./DesignDeliveryView.vue?vue&type=script&lang=js"
import style0 from "./DesignDeliveryView.vue?vue&type=style&index=0&id=0acd3165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd3165",
  null
  
)

export default component.exports